import "./filter.scss";
import gif from "./assets/filter.gif";
import site from "./assets/site.png";
import title from "./assets/title.png";
import { fade, rise } from "../fade.js";
import { motion } from "framer-motion";

const Filter = () => {
  return (
    <section class="section filter">
      <motion.img
        src={title}
        alt="Bringing Fans into the Money Heist Universe"
        className="title"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      />
      <motion.p
        className="copy"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      >
        We created an Instagram AR Filter, where fans would be given an
        Indonesian city name as their Money Heist character name.
      </motion.p>
      <motion.img
        src={gif}
        alt="AR FILTER"
        className="gif"
        variants={rise}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      />
      <motion.p
        className="copy"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      >
        We then tied up the campaign by compiling all of the contributions to
        form a giant Dali Mask.
      </motion.p>
      <motion.a
        href="https://www.haveaheistday.com/"
        target="_blank"
        className="btn"
        initial={{ opacity: 0, scale: 0 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.9 }}
      >
        Behold the mosaic
      </motion.a>
      <motion.img
        src={site}
        className="mosaic"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      />
    </section>
  );
};

export default Filter;
